import { useMemo } from 'react';

import { getPrimaryContact } from './ContactService';
import type { Email } from './ContactTypes';
import { useEmails } from './useEmails';

interface PrimaryEmailState {
    isLoading: boolean;
    hasError: boolean;
    email: Email | undefined;
}

export const usePrimaryEmail = (): [PrimaryEmailState, () => void] => {
    const [{ isLoading, hasError, emails }, fetchContacts] = useEmails();
    const email = useMemo(() => getPrimaryContact(emails), [emails]);

    return [
        {
            isLoading,
            hasError,
            email,
        },
        fetchContacts,
    ];
};
